<template>
  <div>
    <b-modal id="modalEditISGattributesSettings" ref="modalEditISGattributesSettings" :title="$t('ISG attributes')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" :label="$t('Attribute')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.attr_id" aria-describedby="inputFeedbackAttribute" :state="editItem.attr_id > 0"/>
          <b-form-invalid-feedback id="inputFeedbackAttribute">
              {{ $t('Enter number') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Vendor')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.vendor_id" aria-describedby="inputFeedbackVendor" :state="editItem.vendor_id >= 0"/>
          <b-form-invalid-feedback id="inputFeedbackVendor">
              {{ $t('Enter number') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.attr_name" aria-describedby="inputFeedbackName" :state="editItem.attr_name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
              {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditISGattributesSettings')" size="md"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  methods: {
    save () {
      if (!this.editItem.attr_id) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attribute fields is invalid'), 'Error')
        return
      }
      if (this.editItem.vendor_id < 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Vendor fields is invalid'), 'Error')
        return
      }
      if (!this.editItem.attr_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }

      this.editItem.attr_id = Number(this.editItem.attr_id)
      this.editItem.vendor_id = Number(this.editItem.vendor_id)
      this.editItem.isg_attr_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_ISG_ATTRIBUTES', this.editItem)
        : this.$store.dispatch('Settings/CREATE_ISG_ATTRIBUTES', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ISG_ATTRIBUTES')
          this.$refs.modalEditISGattributesSettings.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/ISGattributes/editModal.vue